module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Spy-e3c3db3ab61f5b99908e665ec4de6849.svg";